import React from 'react';
import css from './index.module.scss';
import SiteFooter from './SiteFooter';

interface Props {
  merchantPublicId?: string | null;
}

const MerchantGlobalFooter: React.FC<Props> = ({ merchantPublicId }) => {
  return (
    <footer className={css.MerchantGlobalFooter}>
      <SiteFooter merchantPublicId={merchantPublicId} />
    </footer>
  );
};

export default MerchantGlobalFooter;
